var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5C0 9.17816 9.17816 0 20.5 0C31.8218 0 41 9.17816 41 20.5C41 31.8218 31.8218 41 20.5 41C9.17816 41 0 31.8218 0 20.5Z",
    fill: "url(#paint0_linear_4_126)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.5C1 9.73045 9.73045 1 20.5 1C31.2696 1 40 9.73045 40 20.5C40 31.2696 31.2696 40 20.5 40C9.73045 40 1 31.2696 1 20.5Z",
    stroke: "url(#paint1_linear_4_126)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5373 8.63382C17.5373 8.63382 17.1467 12.4849 17.7335 13.1055C18.3202 13.7262 21.9415 15.1619 22.6272 16.336C23.313 17.51 22.7898 19.5346 27.1622 23.223C28.7864 24.5933 27.9523 30.9517 26.7381 32.1647C25.3348 33.5686 18.5199 35.0008 15.4837 33.0452C13.103 31.5104 12.3519 27.6275 12.4491 26.4535C12.5463 25.2794 16.005 20.0244 16.9841 18.5886C17.9632 17.1529 15.5155 16.3696 15.2875 15.3582C15.0595 14.3468 15.6463 10.1014 17.5373 8.63382Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2466 18.8734C25.6281 19.2995 24.3874 17.8691 24.3874 17.0221C24.3874 16.1734 25.7748 15.0294 25.4973 12.8775C25.4973 12.8758 27.5845 17.9522 26.2466 18.8734Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0278 12.8756C20.0681 12.2356 19.4301 11.1782 19.5927 10.264C19.7553 9.3499 20.9306 7.52338 20.897 7C20.897 7 20.57 10.0024 21.0278 10.8193C21.4837 11.6361 21.8107 13.399 21.0278 12.8756Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2093 20.6431C14.2093 20.6431 15.8723 18.9456 15.0894 17.6407C14.3065 16.3358 14.0131 15.1936 14.0449 14.3112C14.0467 14.313 12.5144 19.5008 14.2093 20.6431Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2314 24.2328L21.0523 24.4857L20.1227 25.7871L18.9209 24.7315L16.7418 24.9843L15.8121 26.2857L16.0702 28.5083L20.8349 31.9474L24.6895 27.511L24.4332 25.2884L23.2314 24.2328Z",
    fill: "#F47421"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_126",
    x1: 20.5,
    y1: 0,
    x2: 20.5,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_126",
    x1: 20.5,
    y1: 0,
    x2: 20.5,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9301",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.1165b3a58c6ad1030860028be37686fe.svg";
export { ForwardRef as ReactComponent };